import type { FaireProductEntity } from "../../entity_types/product";

export const p_5hz8dwbaf7: FaireProductEntity = {
  token: "p_5hz8dwbaf7",
  type: "product",
  name: "RAE RAE - Athleisure Sneaker w/ Gum Sole, Suede Detail",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/2233d828fbae404e502084075fb4b7ee0f6e9237733ff1d0141bda9dfbda0ccd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34f3ba1c1a65075612068c4a2c308614b8440761d080c1e2577417cfed2ba8b2.jpeg",
    "https://cdn.faire.com/fastly/8d1892247b220e4d40c3d59223646d89ab391292af904232970a48e923a62791.jpeg",
    "https://cdn.faire.com/fastly/82117c0b533fb7fdf8a2f3d84388a202553e7a52856d646e4b64e26a9791c376.jpeg",
    "https://cdn.faire.com/fastly/000248cd15b7c8f377e546191c918b096e9ee1528db4ca9a00d89d300b369b19.jpeg",
    "https://cdn.faire.com/fastly/544e777bb8659dfbb534475f98499ea3333308eac29e6e96cbccb060b3c926f6.jpeg",
    "https://cdn.faire.com/fastly/93c782b18d03090f4a3a96f9c9d33827b03810a2837278c89d17c60eff762b3c.jpeg",
    "https://cdn.faire.com/fastly/a6a04bdba8f9a0bd8c6db5767bc4929240213b27153ed50eeeeceff4e9d85220.jpeg",
    "https://cdn.faire.com/fastly/99fac8757d6e82f3d5e9acd2aadf76cc54c78932667eff9224ad67ad702049aa.jpeg",
    "https://cdn.faire.com/fastly/0a21c271cf0d93018f4becad7a489e2c0ac5e7fe40af0267063114e91e8f65bd.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg",
  ],
  priceDollars: 19,
  description:
    "Meet the Rae Rae sneaker, your new go-to for both style and comfort in your active lifestyle. These sneakers feature a sleek, taupe upper with a contrasting suede panel, offering a modern, earthy look perfect for any casual outing. The thick, white midsole not only provides excellent cushioning for all-day wear but also adds a trendy, chunky aesthetic. The gum rubber outsole ensures great traction, making them ideal for both city streets and light sports activities.\n\n𝐎𝐎𝐓𝐃:\nStyle them with your favorite athleisure wear for a sporty vibe, as shown with the tennis court setting, or pair with jeans and a casual tee for a laid-back day out. The Rae Rae sneaker is designed to keep you moving in style, whether you're hitting the courts or exploring urban landscapes.\n\n• See size chart for case breakdown\n• Sneaker\n• Accent on sides\n• Colors: White, Taupe",
  tags: [],
  msrpDollars: 45,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:18.685Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
